<template>
  <div class="table-responsive bg-white radius">
    <ArchivedTasks class="m-4" scope="ACCOUNT"></ArchivedTasks>
  </div>
</template>

<script>
import ArchivedTasks from "./archived-tasks.vue";
export default {
  components: { ArchivedTasks },

  computed: {},
};
</script>
